/* eslint-disable no-nested-ternary */
import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";

interface Props {
  dataTestId?: string;
  price: number;
  divideQuantity?: number;
  divideByUnit?: string;
  fontColorClassName?: string;
  unitFontSize?: string;
  quantityDiscountPrice?: number;
  additionalClassnames?: string;
}
const DivideByPricing = ({
  dataTestId = "",
  price,
  divideQuantity = 1,
  divideByUnit = "",
  fontColorClassName = "text-gray-800",
  unitFontSize = "",
  quantityDiscountPrice,
  additionalClassnames,
}: Props) => {
  const displayedPrice = () => {
    if (quantityDiscountPrice && quantityDiscountPrice > 0) {
      const divideByPrice = quantityDiscountPrice / divideQuantity;
      return divideByPrice > 0.01
        ? formatAsCurrency.formatIfUndefined(divideByPrice)
        : "$0.01";
    }
    const divideByPrice = price / divideQuantity;
    return divideByPrice > 0.01
      ? formatAsCurrency.formatIfUndefined(divideByPrice)
      : "$0.01";
  };

  return divideQuantity > 0 && divideByUnit ? (
    <span data-testid={dataTestId} className="block">
      <span
        className={`block text-xs leading-[12px] m-0 font-normal ${fontColorClassName} ${additionalClassnames}`}
      >
        {displayedPrice()}/<span className={unitFontSize}>{divideByUnit}</span>
      </span>
    </span>
  ) : (
    <></>
  );
};

export default DivideByPricing;
